import { GeometryUtils, PrecisionUtils } from "../../infra3d";
import { GEOMETRYTYPE } from "../featuretree/internal";
import { MEASUREMODE } from "../internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { Tool } from "./internal";
/**
 * Draw Polygon Tool
 * @class DrawPolygonTool
 * @extends {Tool}
 */
export class DrawPolygonTool extends Tool {
    constructor(scene, toolhandler, options, name, group) {
        super(scene, toolhandler);
        this.featurecollection = null;
        this.pointfeature = null;
        this.polygonfeature = null;
        this.multipointfeature = null;
        this.linestringfeature = null;
        this.tempposarray = [];
        this.posArray = [];
        this.toolstate = -1;
        this.coordinates = [];
        // event variables
        this.mouseupeventnr = null;
        this.mousemoveeventnr = null;
        this.mouseouteventnr = null;
        this.resetinputevent = null;
        this.finishinputevent = null;
        this.undoinputevent = null;
        this.holdeventnr = null;
        this.releaseeventnr = null;
        this.drageventnr = null;
        this.doubletapeventnr = null;
        this.swipeeventnr = null;
        this.tempcoordinates = [];
        this.snap_mx = null;
        this.snap_my = null;
        this.snappedpos = null;
        this.fixedElevation = false;
        this.pos = null;
        this.evt = null;
        this.pointpending = false;
        this.name = name;
        this.group = group;
        //options - set the default values here....
        const defaultoptions = {
            pointsetcbf: null,
            undoinput: USERINPUTTYPE.KEY_DELETE,
            calcarea: true,
            precGlobalTreshold: 5.0, // NOTE: [sec]
        };
        for (const property in defaultoptions) {
            this.options[property] = defaultoptions[property];
        }
        super.parseOptions(options);
        //create the drawing layers
        this.featurecollection = this.scene
            .getFeatureHandler()
            .createFeatureCollection(this.options.layerstyle, this.options.highlightlayerstyle, "mmDrawingToolPolygonCollection_internal", false);
        this.pointfeature = this.featurecollection.createFeature();
        this.pointfeature.geometry = this.pointfeature.createGeometry(GEOMETRYTYPE.POINT);
        this.polygonfeature = this.featurecollection.createFeature();
        this.polygonfeature.geometry = this.polygonfeature.createGeometry(GEOMETRYTYPE.POLYGON);
        this.multipointfeature = this.featurecollection.createFeature();
        this.multipointfeature.geometry = this.multipointfeature.createGeometry(GEOMETRYTYPE.MULTIPOINT);
        this.linestringfeature = this.featurecollection.createFeature();
        this.linestringfeature.geometry = this.linestringfeature.createGeometry(GEOMETRYTYPE.LINESTRING);
        this.type = "DrawPolygonTool";
    }
    /**
     * internal function - to activate tool call .enable
     * @method _enableTool
     * @protected
     */
    _enableTool() {
        this.enabled = true;
        this._SubscribeEvents();
        if (this.options.modifycursor) {
            this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
        }
        this.fire(DrawPolygonTool.enabled, this.options["cbobject"]);
        this.toolstate = 0;
    }
    /**
     * internal function - to disable tool call .disable
     * @method _disableTool
     * @protected
     */
    _disableTool() {
        this.enabled = false;
        this.reset();
        if (this.options.modifycursor) {
            this.scene.getCursorStyleHandler().setCursorStyle("default");
            this.scene.getMeasureModeHandler().hideMeasureModeCursor();
        }
        this.fire(DrawPolygonTool.disabled, this.options["cbobject"]);
        this._unSubscribeEvents();
        this.toolstate = -1;
    }
    _SubscribeEvents() {
        //check if  events aren't already subscribed
        if (!this.enabled || this.mouseupeventnr != null)
            return;
        this.mouseupeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEUP, this._onMouseUp, this);
        this.doubletapeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.DOUBLETAP, this._onDoubletap, this);
        if (this.options.undoinput) {
            this.undoinputevent = this.scene.userInputHandler.subscribeEvent(this.options.undoinput, this._undo, this);
        }
        if (this.options.resetinput) {
            this.resetinputevent = this.scene.userInputHandler.subscribeEvent(this.options.resetinput, this.reset, this);
        }
        if (this.options.finishinput) {
            this.finishinputevent = this.scene.userInputHandler.subscribeEvent(this.options.finishinput, this._finishmeasurement, this);
        }
        if (this.options.continousdraw) {
            this.mousemoveeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._onMouseMove, this);
        }
        this.mouseouteventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEOUT, this._onMouseOut, this);
        if (this.options.enablecbf != null) {
            this.on(DrawPolygonTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.on(DrawPolygonTool.disabled, this.options.disablecbf);
        }
        if (this.options.pointsetcbf != null) {
            this.on(DrawPolygonTool.pointset, this.options.pointsetcbf);
        }
        if (this.options.continousdrawcbf != null) {
            this.on(DrawPolygonTool.continousdraw, this.options.continousdrawcbf);
        }
        if (this.options.resetcbf != null) {
            this.on(DrawPolygonTool.reset, this.options.resetcbf);
        }
        if (this.options.finishedcbf != null) {
            this.on(DrawPolygonTool.finished, this.options.finishedcbf);
        }
        if (this.options.errorcbf != null) {
            this.on(DrawPolygonTool.error, this.options.errorcbf);
        }
    }
    _unSubscribeEvents() {
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this.mouseupeventnr);
        this.mouseupeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveeventnr);
        this.mousemoveeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEOUT, this.mouseouteventnr);
        this.mouseouteventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.DOUBLETAP, this.doubletapeventnr);
        this.doubletapeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.undoinput, this.undoinputevent);
        this.undoinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.resetinput, this.resetinputevent);
        this.resetinputevent = null;
        this.scene.userInputHandler.unSubscribeEvent(this.options.finishinput, this.finishinputevent);
        this.finishinputevent = null;
        this.scene.getMeasureModeHandler().hideMeasureModeCursor();
        if (this.options.enablecbf != null) {
            this.off(DrawPolygonTool.enabled, this.options.enablecbf);
        }
        if (this.options.disablecbf != null) {
            this.off(DrawPolygonTool.disabled, this.options.disablecbf);
        }
        if (this.options.pointsetcbf != null) {
            this.off(DrawPolygonTool.pointset, this.options.pointsetcbf);
        }
        if (this.options.continousdrawcbf != null) {
            this.off(DrawPolygonTool.continousdraw, this.options.continousdrawcbf);
        }
        if (this.options.resetcbf != null) {
            this.off(DrawPolygonTool.reset, this.options.resetcbf);
        }
        if (this.options.finishedcbf != null) {
            this.off(DrawPolygonTool.finished, this.options.finishedcbf);
        }
        if (this.options.errorcbf != null) {
            this.off(DrawPolygonTool.error, this.options.errorcbf);
        }
    }
    /**
     * The doubletap event.
     * @method _onDoubletap
     * @param evt
     * @private
     */
    _onDoubletap(evt) {
        this.reset(evt);
    }
    /**
     * internal function mousemove
     * @method _onMouseMove
     * @param evt
     * @private
     */
    _onMouseMove(evt) {
        if (this.pointfeature.ishidden) {
            this.pointfeature.show();
        }
        this._measureOnMouseMove(evt);
    }
    /**
     * internal function mouseout
     * @method _onMouseOut
     * @param evt
     * @private
     */
    _onMouseOut(evt) {
        this.pointfeature.hide();
        this.pointfeature.update(true);
    }
    _onMouseUp(evt) {
        if (evt.button > 0) {
            return;
        }
        if (evt.isDragging) {
            this._measureOnMouseMove(evt);
        }
        else {
            const mx = evt.offsetX;
            const my = evt.offsetY;
            this.evt = evt;
            const measuremode = this.scene.getMeasureMode();
            this._unSubscribeEvents();
            //the reset event needs to be still active
            if (this.options.resetinput != null) {
                this.resetinputevent = this.scene.userInputHandler.subscribeEvent(this.options.resetinput, this.reset, this);
            }
            if (this.snappedpos == null) {
                this.scene.getMeasureHandler().createMeasurePointInMeasureMode(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist, (pos) => {
                    if (!pos.warning)
                        this._posRequestSuccess(pos);
                    else {
                        setTimeout(() => {
                            this._SubscribeEvents();
                        }, 10);
                    }
                }, (pos) => {
                    this._posRequestFailed(pos);
                }, measuremode);
            }
            else {
                this._posRequestSuccess(this.snappedpos);
            }
        }
    }
    _measureOnMouseMove(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        if (this._last_mx == mx || this._last_my == my)
            return;
        //to prevent repeated points error in poly2tri...
        if (this.scene.getMeasureModeHandler().overrideMeasureMode != null) {
            //measure mode is overwritten so set last point to second last point
            const len = this.tempcoordinates.length;
            if (len > 1)
                this.tempcoordinates[len - 1] = this.tempcoordinates[len - 2];
            this._draw(this.tempcoordinates);
            if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
                this.scene.getMeasureModeHandler().hideMeasureModeCursor();
            }
            return;
        }
        const mousemovemeasuremode = this.scene.getMeasureModeHandler().mouseMoveMeasureMode;
        if (mousemovemeasuremode == MEASUREMODE.NONE) {
            if (this.options.modifycursor) {
                this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
                this.scene.getMeasureModeHandler().hideMeasureModeCursor();
            }
            return;
        }
        this._checkSnaping(evt);
        if (this.snappedpos) {
            this._pointfound(this.snappedpos);
            return;
        }
        if (this.pointpending)
            return;
        this.pointpending = true;
        //make a measurepoint in mousemove measuremode
        this.scene.getMeasureHandler().createMeasurePointInMeasureMode(this.scene.getCurrentGeoframe(), mx, my, this.options.maxdist, (pos) => {
            this._pointfound(pos);
        }, (msg) => {
            this._pointNotFound(msg);
        }, this.scene.getMeasureModeHandler().mouseMoveMeasureMode);
    }
    _pointNotFound(msg) {
        this.pointpending = false;
        if (!this.enabled)
            return;
        if (this.scene.getMeasureMode() == MEASUREMODE.PANODEPTHMAPINTERSECTION_MULTIVIEW_COMBINED ||
            this.scene.getMeasureMode() == MEASUREMODE.PANODEPTHMAPINTERSECTION_PANO_TWO_CLICK_COMBINED) {
            this.scene.getMeasureModeHandler().showMeasureModeCursor();
        }
        else if (this.options.modifycursor) {
            this.scene.getCursorStyleHandler().setCursorStyle("not-allowed");
        }
        if (this.toolstate > 0) {
            this.fire(DrawPolygonTool.error, this.options["cbobject"], msg, this.evt);
        }
        this.pointfeature.hide();
        return;
    }
    _pointfound(pos) {
        this.pointpending = false;
        if (!this.enabled)
            return;
        this.pos = pos;
        this.pointfeature.show();
        if (this.tempcoordinates.length > 0) {
            this.tempcoordinates[this.tempcoordinates.length - 1] = this.pos;
        }
        else {
            this.tempcoordinates[0] = this.pos;
        }
        if (this.options.modifycursor) {
            this.scene.getCursorStyleHandler().setCursorStyle(this.options.activecursor);
            this.scene.getMeasureModeHandler().hideMeasureModeCursor();
        }
        if (this.tempcoordinates.length > 0) {
            this._draw(this.tempcoordinates);
            const area = this._calcArea(this.tempcoordinates);
            const area2d = this._calcArea2D(this.tempcoordinates);
            const precArea = this._calcPrecisionArea(this.tempcoordinates);
            const precArea2d = this._calcPrecisionArea2D(this.tempcoordinates);
            if (this.toolstate > 0) {
                this.fire(DrawPolygonTool.continousdraw, this.options["cbobject"], {
                    mx: this.evt.offsetX,
                    my: this.evt.offsetY,
                    area: area,
                    precArea: precArea.precision,
                    area2d: area2d,
                    precArea2d: precArea2d.precision,
                    precMode: precArea2d.mode,
                    pos: this.pos,
                    polygonfeature: this.polygonfeature.toGeoJSON(),
                }, this.evt);
            }
        }
    }
    _checkSnaping(evt) {
        const mx = evt.offsetX;
        const my = evt.offsetY;
        if (this.options.snaplayer && !evt.altKey) {
            const snapdataarray = this.scene.getFeatureHandler().snap(mx, my, this.options.snaplayer);
            //prevent self pickcing and filter non-pointy geometries
            for (let i = snapdataarray.length - 1; i >= 0; i--) {
                if (snapdataarray[i].geometry.type != GEOMETRYTYPE.MULTIPOINT &&
                    snapdataarray[i].geometry.type != GEOMETRYTYPE.POINT) {
                    snapdataarray.splice(i, 1);
                }
            }
            if (snapdataarray.length > 0) {
                const snapdata = snapdataarray[0];
                this.snap_mx = snapdata.found_mx;
                this.snap_my = snapdata.found_my;
                this.pos.Easting = snapdata.found_easting;
                this.pos.Northing = snapdata.found_northing;
                this.pos.Height = snapdata.found_height;
                this.pos.warning = false;
                this.snappedpos = this.pos;
            }
            else {
                this.snap_mx = null;
                this.snap_my = null;
                this.snappedpos = null;
            }
        }
    }
    _posRequestFailed(pos) {
        this.reset();
        this.scene.getMeasureHandler().abortMeasureSequence();
        setTimeout(() => {
            this._SubscribeEvents();
        }, 10);
    }
    _posRequestSuccess(pos) {
        setTimeout(() => {
            this._SubscribeEvents();
        }, 10);
        //--- draw a polgon State Machine
        switch (this.toolstate) {
            case 0: //first click, create an new polygon
                if (this.coordinates.length > 0)
                    this._cleanUp();
                if (pos.isValid())
                    this.coordinates[0] = pos;
                this.toolstate += 1;
                break;
            case 1: //second click append coordinates
                if (this.fixedElevation)
                    pos.Height = this.coordinates[0].Height;
                if (pos.isValid())
                    this.coordinates.push(pos);
                this.toolstate += 1;
                break;
            case 2:
                if (this.fixedElevation)
                    pos.Height = this.coordinates[0].Height;
                if (pos.isValid())
                    this.coordinates.push(pos);
                break;
        }
        // check if the last and second last point is the same
        // Check for repeated points
        // check if the last two points are not equal -> occurs if finished by double-click...
        const numpoints = this.coordinates.length;
        if (numpoints > 1) {
            if (this.coordinates[numpoints - 1].Easting == this.coordinates[numpoints - 2].Easting &&
                this.coordinates[numpoints - 1].Northing == this.coordinates[numpoints - 2].Northing &&
                this.coordinates[numpoints - 1].Height == this.coordinates[numpoints - 2].Height) {
                this.coordinates.splice(numpoints - 1, 1);
                this.tempcoordinates.splice(numpoints - 1, 1);
            }
        }
        this._draw(this.coordinates);
        const area = this._calcArea(this.coordinates);
        const area2d = this._calcArea2D(this.coordinates);
        const precArea = this._calcPrecisionArea(this.coordinates);
        const precArea2d = this._calcPrecisionArea2D(this.coordinates);
        this.fire(DrawPolygonTool.pointset, this.options["cbobject"], {
            mx: this.evt.offsetX,
            my: this.evt.offsetY,
            area: area,
            precArea: precArea.precision,
            area2d: area2d,
            precArea2d: precArea2d.precision,
            precMode: precArea2d.mode,
            polygonfeature: this.polygonfeature.toGeoJSON(),
        }, this.evt);
        this.tempcoordinates = this.coordinates.slice(0);
        this.tempcoordinates.push(pos);
        this._last_mx = this.evt.offsetX;
        this._last_my = this.evt.offsetY;
        if (this.scene.getMeasureMode() == MEASUREMODE.LEFTRIGHT) {
            setTimeout(() => {
                this._SubscribeEvents();
            }, 10);
        }
    }
    /**
     * Draws the feature into the scene
     * @method _draw
     * @param {MeasurePoint[]} coors the geometry coordinates
     * @private
     */
    _draw(coors) {
        const coorsarray = [];
        for (let i = 0; i < coors.length; i++) {
            coorsarray.push([coors[i].Easting, coors[i].Northing, coors[i].Height]);
        }
        if (coorsarray.length > 0) {
            this.pointfeature.geometry.coordinates = [coorsarray[coorsarray.length - 1]];
        }
        if (this.toolstate > 0) {
            //Update the features for drawing
            this.polygonfeature.geometry.coordinates = coorsarray.slice(0); //coorsarray.slice());
            //This is here because GeoJSON Standard needs the last point to be the same
            //as the first point!!!
            //this.polygonfeature.geometry.coordinates.push(coorsarray[0]);
            this.multipointfeature.geometry.coordinates = coorsarray.slice(0);
            this.linestringfeature.geometry.coordinates = coorsarray.slice(0); // coorsarray.slice(); //copies the array - maybe this is bad...
            //close the line...
            this.linestringfeature.geometry.coordinates.push(this.linestringfeature.geometry.coordinates[0]);
        }
        this.featurecollection.update();
    }
    _finishmeasurement(evt) {
        if (this.options.continousdraw) {
            this.tempcoordinates.splice(this.tempcoordinates.length - 1, 1);
            this._draw(this.tempcoordinates);
        }
        if (this.toolstate == 0 || this.tempcoordinates.length < 3) {
            this.reset();
            return;
        }
        this.toolstate = 0;
        this.tempcoordinates = [];
        //call the user defined event handler...
        const polygonfeature = this.polygonfeature.toGeoJSON();
        const multipointfeature = this.multipointfeature.toGeoJSON();
        const linestringfeature = this.linestringfeature.toGeoJSON();
        const area = this._calcArea(this.coordinates);
        const area2d = this._calcArea2D(this.coordinates);
        const precArea = this._calcPrecisionArea(this.coordinates);
        const precArea2d = this._calcPrecisionArea2D(this.coordinates);
        const pos = this.coordinates.slice(-1)[0];
        this.fire(DrawPolygonTool.finished, this.options["cbobject"], {
            polygonfeature: polygonfeature,
            multipointfeature: multipointfeature,
            linestringfeature: linestringfeature,
            area: area,
            precArea: precArea.precision,
            area2d: area2d,
            precArea2d: precArea2d.precision,
            precMode: precArea2d.mode,
            mx: pos["mouseX"],
            my: pos["mouseY"],
            measurepoint: pos,
        }, evt);
    }
    /**
     * removes all drawing from the scene
     * @method _cleanUp
     * @private
     */
    _cleanUp() {
        this.scene.getMeasureHandler().abortMeasureSequence();
        this.pointpending = false;
        if (this.coordinates.length > 0) {
            this.coordinates = [];
            this.tempcoordinates = [];
            this.tempposarray = [];
            this.posArray = [];
        }
        this.polygonfeature.geometry.clear();
        this.multipointfeature.geometry.clear();
        this.pointfeature.geometry.clear();
        this.linestringfeature.geometry.clear();
        this.scene.getMeasureHandler().abortMeasureSequence();
        this.featurecollection.update();
    }
    /**
     *  resets the tool and calls the aborted event
     *  @method reset
     *  @param {?Object} evt EventObject if called from userinput
     *  @public
     */
    reset(evt) {
        this._cleanUp();
        this.toolstate = 0;
        this.coordinates = [];
        this.fire(DrawPolygonTool.reset, this.options["cbobject"], evt);
    }
    destroy() {
        this._cleanUp();
        this.featurecollection.destroy();
        this.featurecollection = null;
    }
    /**
     *  removes the last added point
     *  @method _undo
     *  @private
     */
    _undo() {
        this.coordinates.pop();
        this.tempcoordinates.pop();
        this._draw(this.coordinates);
    }
    /**
     *  removes all drawing from the scene
     *  @method setElevationFixed
     */
    setElevationFixed() {
        this.fixedElevation = true;
    }
    /**
     *  removes all drawing from the scene
     *  @method resetElevationFixed
     */
    resetElevationFixed() {
        this.fixedElevation = false;
    }
    _calcArea(coords) {
        if (!this.options.calcarea)
            return 0.0;
        return GeometryUtils.CalcArea(coords);
    }
    _calcArea2D(coords) {
        if (!this.options.calcarea)
            return 0.0;
        return GeometryUtils.CalcArea2D(coords);
    }
    _calcPrecisionArea(coords) {
        if (!this.options.calcarea) {
            return {
                precision: 0.0,
                mode: null,
            };
        }
        const mode = this._precisionMode(coords);
        if (mode === "local") {
            return {
                precision: PrecisionUtils.areaLocal(coords),
                mode: mode,
            };
        }
        else if (mode === "global") {
            return {
                precision: PrecisionUtils.areaGlobal(coords),
                mode: mode,
            };
        }
    }
    _calcPrecisionArea2D(coords) {
        if (!this.options.calcarea) {
            return {
                precision: 0.0,
                mode: null,
            };
        }
        const mode = this._precisionMode(coords);
        if (mode === "local") {
            return {
                precision: PrecisionUtils.area2DLocal(coords),
                mode: mode,
            };
        }
        else if (mode === "global") {
            return {
                precision: PrecisionUtils.area2DGlobal(coords),
                mode: mode,
            };
        }
    }
    _precisionMode(coords) {
        const timestamps = [];
        for (let i = 0; i < coords.length; i++) {
            timestamps.push(new Date(coords[i].geoframe.timestamp) / 1000.0);
        }
        const diff = Math.max(...timestamps) - Math.min(...timestamps);
        if (diff > this.options.precGlobalTreshold) {
            return "global";
        }
        return "local";
    }
}
DrawPolygonTool.enabled = "enabled";
DrawPolygonTool.disabled = "disabled";
DrawPolygonTool.pointset = "pointset";
DrawPolygonTool.continousdraw = "continousdraw";
DrawPolygonTool.reset = "reset";
DrawPolygonTool.finished = "finished";
DrawPolygonTool.error = "error";
//# sourceMappingURL=drawpolygontool.js.map